/**
 * 系統timerout 倒數 popup
 */
export class TimeoutPopupViewForm {

    /** 顯示的Title文字 */
    title: string = '';

    systemIxd: string;

    errorCode: string = '';

    /** 錯誤訊息 */
    errorDesc: string = '';

    /** timeout時間 */
    timeout: number = -1;


}
